import React, { Component } from 'react'
import {connect} from 'react-redux'

class MobileMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 0
    }
  }

  updateQuantity() {
    let cartItems = 0
    let monthProducts = this.props.cart.filter(item => {
        return item.month === this.props.data.value
     })
    monthProducts.map((item) => {
      return cartItems += item.quantity
    })
    this.setState({quantity: cartItems})
  }

  componentDidMount() {
    this.updateQuantity()
  }

  render() {
    return (
      <div
        className="MobileMonth-option"
        ref={this.props.innerRef}
        {...this.props.innerProps}>
        <p>{this.props.data.label}</p>
        {
          this.state.quantity > 0
          ?
          <div className="MobileMonth-quantity">
            <p>{this.state.quantity}</p>
          </div>
          :
          null
        }
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    cart: state.cart,
    check: 5,
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileMonth);



// WEBPACK FOOTER //
// ./src/components/MobileMonth.jsx